
import React from 'react';
import { Animated, Image, StyleSheet, View } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

import Images from '../../state/stores/Image/images';
import PressableScale from '../PressableScale/PressableScale';
import { H3, ParagraphSRegular } from '../../config/designSystem/typography';
import { MAX_WIDTH } from '../../config/designSystem/Colors';
import { REGULAR_MARGIN_VERTICAL_FN, SMALL_MARGIN_VERTICAL_FN, WIDTH_OTHERS_FN, isAndroid } from '../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useIsSmallWeb } from '../../hooks/ui/useIsSmallWeb';


export const AssistanceItem = observer(
  ({
    title,
    text,
    onPress,
    hasIconInternal,
    hasIconEvoluno,
    backgroundColor,
  }: {
      title: string;
      text: string;
      onPress: any;
      hasIconInternal: boolean;
      hasIconEvoluno: boolean;
      backgroundImage?: string;
      backgroundColor: string;
    }) => {
    const scaleAnimation = React.useRef(new Animated.Value(1)).current;
    const { height, width } = useAvailableDimensions();
    const WIDTH_VIEW = Math.min(MAX_WIDTH, width - 2 * REGULAR_MARGIN_VERTICAL_FN(width));
    const shadowColor = isAndroid ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.2)';
    const {isLargeEnoughForLateralBarWeb} = useIsSmallWeb();
    return (
      <PressableScale
        scaleAnimation={scaleAnimation}
        style={{
          marginHorizontal: REGULAR_MARGIN_VERTICAL_FN(width),
          marginVertical: 10,
        }}
        onPress={onPress}
      >
        <Animated.View
          style={[
            {
              transform: [{ scale: scaleAnimation }],
            },
            {
              borderRadius: 20,
              overflow: 'hidden',
              width: WIDTH_VIEW
            },
            !isLargeEnoughForLateralBarWeb && {
              elevation: 8,
              minWidth: 150,
              backgroundColor: backgroundColor,
              shadowColor,
              shadowRadius: 21,
              shadowOffset: {
                width: 0,
                height: 4,
              },
              shadowOpacity: 1,
            },
            isLargeEnoughForLateralBarWeb && {
              shadowColor,
              shadowRadius: 5,
              shadowOffset: {
                width: 0,
                height: 0,
              },
              elevation: 8,
              backgroundColor: backgroundColor,
              width: '70vw',
              shadowOpacity: 1,
              borderRadius: 20,
              overflow: 'hidden',
            },
          ]}
        >
          {/* Static elements of the  page */}
          <View style={styles.textContainer} >
            <View style={{ marginVertical: SMALL_MARGIN_VERTICAL_FN(height), flex: 1 }} >
              <View style={[styles.iconContainer]}>
                {hasIconInternal && <>
                  <FontAwesome5 name="house-user" color={'#ff6666'} size={30}/>
                </>}
                {hasIconEvoluno && <View><Image source={Images.logo.icon} style={ { height: 50, width: 50 }}></Image></View>}

                <View style={{ paddingTop: 10, marginHorizontal: 30 }}>
                  <H3 size={WIDTH_OTHERS_FN(width) / 5}>{title}</H3>
                </View>
              </View>
              <View style={{ width: '90%', marginLeft: 20, marginTop: 15 }}>
                <ParagraphSRegular >{text}</ParagraphSRegular>
              </View>
            </View>
          </View>
        </Animated.View>
      </PressableScale>
    );
  },
);

const styles = StyleSheet.create({
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems:'center',
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: 10,
    paddingHorizontal: 20,
  },

}
);